import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ProjectsProvider } from './ProjectsContext';
import App from './App';

ReactDOM.render(
  <AuthProvider>
    <ProjectsProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ProjectsProvider>
  </AuthProvider>,
  document.getElementById('root')
);
